import { getOffsetTop } from '../../../../src/js/utils/functions';

const addHeroOffset = () => {
	const hero = document.querySelector('.block-hero') as HTMLDivElement | null;
	if (null !== hero && !hero.classList.contains('block-hero--no-sticky')) {
		const height = hero.offsetHeight;
		const pageContent = document.querySelector('.page-content') as HTMLDivElement | null;

		const rootStyles = getComputedStyle(document.documentElement);
		const headerHeight = parseInt(
			rootStyles.getPropertyValue('--headerHeightFull').replace('px', '').trim()
		);

		const mobileBarOffset = window.matchMedia(`(min-width: ${gridBreakpoints.lg}px)`).matches
			? 0
			: 80;

		if (pageContent) {
			if (headerHeight + height + mobileBarOffset > window.innerHeight) {
				document.body.classList.add('no-sticky-hero');
				pageContent.style.paddingTop = '';
			} else {
				document.body.classList.remove('no-sticky-hero');

				if (hero.classList.contains('block-hero--bg-video')) {
					pageContent.style.paddingTop = `calc(${height}px - var(--headerHeightFull) - 50px)`;
				} else {
					pageContent.style.paddingTop = `${height}px`;
				}

				hero.classList.add('block-hero--padding-added');
			}
		}
	}
};

const checkVisibility = () => {
	const hero = document.querySelector('.block-hero') as HTMLDivElement | null;

	const isInSection = hero?.parentElement?.classList.contains('block-section__wrapper') ?? false;
	if (null !== hero && !hero.classList.contains('block-hero--no-sticky')) {
		const nav = document.querySelector('.main-header') as HTMLElement | null;
		const adminBarOffset = document.getElementById('wpadminbar')?.offsetHeight ?? 0;
		const navHeight = nav ? nav.offsetHeight : 0;
		const height = hero.offsetHeight + navHeight;
		const scrollPos = window.scrollY + adminBarOffset;

		if (scrollPos > height) {
			hero.classList.add('is-hidden');
		} else {
			hero.classList.remove('is-hidden');
		}

		if (isInSection && hero.parentElement) {
			const section = hero.parentElement;
			if (scrollPos + window.innerHeight > section.offsetHeight + getOffsetTop(section)) {
				hero.classList.add('stick-to-bottom');
				hero.style.bottom = `${window.innerHeight - hero.offsetHeight - navHeight}px`;
			} else {
				hero.classList.remove('stick-to-bottom');
				hero.style.bottom = '';
			}
		}
	}
};

addHeroOffset();
window.addEventListener('load', addHeroOffset);
window.addEventListener('resize', addHeroOffset, { passive: true });
window.addEventListener('scroll', checkVisibility, { passive: true });
